<template>
  <div >
    <v-btn
      v-if="hasRole('super-admin') && comBotao"
      color="success"
      dark
      fab
      x-small
      @click.native="openLogs()"
    >
      <v-icon>mdi-account</v-icon>
    </v-btn>

    

  <v-snackbar color="primary" shaped v-model="modelLogs" :vertical="false" @input="hide">
    <div v-for="(log, index) in lista_logs" :key="index">
      <b-tag type="is-success" rounded v-if="log.description === 'created'" style="font-size: 15px"
        >Criou:</b-tag
      >
      <b-tag type="is-info" class="mt-1" rounded v-if="log.description === 'updated'" style="font-size: 15px"
        >Atualizou:
      </b-tag>
      <b-tag type="is-danger" class="mt-1" rounded v-if="log.description === 'deleted'" style="font-size: 15px"
        >Deletou:
        
      </b-tag>

      {{ log.nome_completo }}
       <span v-if="log.description === 'deleted'" style="font-size: 15px"
        >| motivo: {{log.properties.attributes.motivo}}
        
      </span>
      <br v-if="index !== logs.length - 1" />
    </div>

    <span v-if="logs.length == 0"
      >sem logs
      <br />
    </span>

    <!-- <span style="font-size: 15px; margin-top: 10px;">DELETOU: {{ user_up.toUpperCase() }} </span> -->

    <template v-slot:action="{ attrs }">
      <v-btn color="error" icon v-bind="attrs" @click.native="hide">
        <v-icon large> mdi-close </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</div>
</template>
<script>
import { hasRole } from "@/utils/can";

export default {
  name: "LogsAlvaras",

  props: {
    comBotao: {
      required: null,
      type: Boolean,
      default:false,
    },

    model: {
      required: null,
      type: Boolean,
    },
    logs: {
      required: null,
      type: Array,
    },
  },
  data() {
    return {
     modelLogs:this.model
     
    };
  },
  computed:{
  lista_logs(){
    const lastLogs = {};
      this.logs.forEach((log) => {
        lastLogs[log.description] = log;
      });
      return Object.values(lastLogs);
  }
  },
  methods: {
    hasRole,
  hide() {
    this.$emit('update:model', false);

    this.modelLogs = false
  },
  openLogs(){
    this.modelLogs = true
  }

},

};
</script>
